import { defineNuxtPlugin } from "#app";

import vuetify from "~/plugins/vuetify";
import vueDebounce from "vue-debounce";
import VueCountdown from "@chenfengyuan/vue-countdown";

import "@mdi/font/css/materialdesignicons.css";
import "~/assets/css/main.scss";
import "~/assets/css/main.css";
import "~/assets/css/typography.css";

export default defineNuxtPlugin((nuxtApp) => {
  const app = nuxtApp.vueApp;

  app.use(vuetify);
  app.directive("debounce", vueDebounce({ lock: true }));
  app.component(VueCountdown.name, VueCountdown);
});
